var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.969 2.469C7.03867 2.39916 7.12143 2.34374 7.21255 2.30593C7.30366 2.26812 7.40135 2.24866 7.5 2.24866C7.59865 2.24866 7.69633 2.26812 7.78745 2.30593C7.87857 2.34374 7.96133 2.39916 8.031 2.469L17.031 11.469C17.1008 11.5387 17.1563 11.6214 17.1941 11.7126C17.2319 11.8037 17.2513 11.9014 17.2513 12C17.2513 12.0987 17.2319 12.1963 17.1941 12.2875C17.1563 12.3786 17.1008 12.4613 17.031 12.531L8.031 21.531C7.89017 21.6718 7.69916 21.751 7.5 21.751C7.30083 21.751 7.10983 21.6718 6.969 21.531C6.82817 21.3902 6.74905 21.1992 6.74905 21C6.74905 20.8008 6.82817 20.6098 6.969 20.469L15.4395 12L6.969 3.531C6.89915 3.46133 6.84374 3.37857 6.80593 3.28745C6.76812 3.19633 6.74866 3.09865 6.74866 3C6.74866 2.90135 6.76812 2.80367 6.80593 2.71255C6.84374 2.62143 6.89915 2.53867 6.969 2.469Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/chevronRight.58d9a8ecd1e87fd4c269fed184ba6b30.svg";